module.exports = __webpack_public_path__ + "static/img/bg61.a0b95d12.png";